export enum VerificationTypeError {
    // Expired token type error
    EXPIRED_TOKEN = 'expired-token',
    // Validation type error
    VALIDATION_ERROR = 'validation-error',
    // Unknown error occurred.
    UNKNOWN_ERROR = 'unknown-error',
}

export enum VerificationError {
    // Referrer value passed is invalid
    INVALID_CONFIGURATION = 'invalid-configuration',
    // Unknown error occurred.
    UNKNOWN_ERROR = 'unknown-error',
}
